export const getDomain = () => {
	const url = new URL(window.location.href);
	return url.hostname;
};

export const getSubdomain = () => {
	const url = new URL(window.location.href);
	return url.hostname.split('.').slice(-2).join('.');
};
